window.Sparkle ??= {};
window.Sparkle.LocationBrowser ??= {};
window.Sparkle.LocationBrowser.Routers ??= {};

Sparkle.LocationBrowser.Routers.MapRouter = class MapRouter extends Backbone.Router {
  constructor() {
    super(...arguments);
    this.noLocation = this.noLocation.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.findByAddress = this.findByAddress.bind(this);
    this.findByZip = this.findByZip.bind(this);
    this.findWithinDistance = this.findWithinDistance.bind(this);
    this.findClosest = this.findClosest.bind(this);
    this.scrollToAnchor = this.scrollToAnchor.bind(this);
    this.startOver = this.startOver.bind(this);
    this.resultCount = this.resultCount.bind(this);
    this.lookupAddressCoordinates = this.lookupAddressCoordinates.bind(this);
  }

  initialize(container, locations, callbacks) {
    this.container = container;
    this.locations = locations;
    if (callbacks == null) {
      callbacks = {};
    }
    this.callbacks = callbacks;
    this.geocoder = new google.maps.Geocoder();

    this.callbacks = jQuery.extend(
      {
        results() {},
        noResults() {},
        reset() {},
      },
      this.callbacks,
    );

    if (this.locations.models.length) {
      return this.callbacks.results();
    } else {
      return this.locations.once("reset", this.callbacks.reset);
    }
  }

  // BEHAVIOUR

  // ROUTING CALLBACKS

  noLocation() {
    this.locations.changeSearchParams();
    return this.callbacks.results();
  }

  selectLocation(slug) {
    jQuery(document).trigger("search.sparkle", ["location-browser", { name: slug }, null, this.resultCount()]);
    this.locations.changeParentParams({ url: `/locations/${slug}` });
    if (this.locations.currentParent) {
      return this.callbacks.results();
    } else {
      return this.callbacks.noResults();
    }
  }

  findByAddress(address) {
    jQuery(document).trigger("search.sparkle", ["location-browser", address, null, this.resultCount()]);
    return this.lookupAddressCoordinates(address)
      .done((lat, lng) =>
        this.findWithinDistance(address, lat, lng, window.SparkleConfig.locationBrowser.searchRadiiMax),
      )
      .fail(this.noResults);
  }

  findByZip(zip, slug) {
    this.locations.changeSearchParams({ name: zip, zip }, { url: `/locations/${slug}` });
    if (this.resultCount()) {
      jQuery(document).trigger("search.sparkle", ["location-browser", zip, null, this.resultCount()]);
      return this.callbacks.results();
    } else {
      return this.lookupAddressCoordinates(zip)
        .done((lat, lng) => this.findClosest(zip, lat, lng))
        .fail(this.noResults);
    }
  }

  findWithinDistance(name, lat, lng, range, slug = "") {
    jQuery(document).trigger("search.sparkle", ["location-browser", { name, range }, null, this.resultCount()]);
    this.locations.changeSearchParams({ name: this.decodeName(name), lat, lng, range }, { url: `/locations/${slug}` });
    if (this.resultCount()) {
      return this.callbacks.results();
    } else {
      return this.callbacks.noResults();
    }
  }

  findClosest(name, lat, lng, slug = "") {
    jQuery(document).trigger("search.sparkle", [
      "location-browser",
      { name, range: "closest" },
      null,
      this.resultCount(),
    ]);
    this.locations.changeSearchParams({ name: this.decodeName(name), lat, lng }, { url: `/locations/${slug}` });
    if (this.resultCount()) {
      return this.callbacks.results();
    } else {
      return this.callbacks.noResults();
    }
  }

  scrollToAnchor() {
    if (!window.location.hash) {
      return;
    }

    // Ensure anchor is visible in mobile
    jQuery(this.container).find("#grid-mobile-show-button").trigger("click");

    const element = jQuery(window.location.hash).get(0);
    return element != null ? element.scrollIntoView() : undefined;
  }

  // HELPER METHODS

  startOver() {
    return this.navigate("");
  }

  resultCount() {
    return (this.locations.searchScope || this.locations).length;
  }

  lookupAddressCoordinates(address) {
    const deferred = jQuery.Deferred();

    this.geocoder.geocode({ address, region: "US" }, (results, status) => {
      if (status === "OK") {
        return deferred.resolve(results[0].geometry.location.lat(), results[0].geometry.location.lng());
      } else {
        return deferred.reject(new Error(`Couldn't find the location ${address}`));
      }
    });

    return deferred.promise();
  }

  decodeName(name) {
    return decodeURI(name)
      .replace(/_/g, ", ")
      .replace(/\u2014/g, " ");
  }
};

Sparkle.LocationBrowser.Routers.MapRouter.prototype.routes = {
  "": "noLocation",
  "find/zip/:zip(/*slug/focus)": "findByZip",
  "find/address/:address": "findByAddress",
  "find/state/:state": "selectLocation",
  "find/coordinates/:name/:lat/:lng/closest(/*slug/focus)": "findClosest",
  "find/coordinates/:name/:lat/:lng/:range(/*slug/focus)": "findWithinDistance",
  "find/*slug/focus": "selectLocation",
  ":anchor": "scrollToAnchor",
};
